module.exports = __webpack_public_path__ + "img/shape-2-copy-4.9d844036.svg";